"use client";

import { useEffect, useState } from "react";
import { loginWithToken } from "@/lib/auth-utils";

export default function AuthProvider({ children }: { children: React.ReactNode }) {
  const [isScreenLoaded, setIsScreenLoaded] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      //   console.log("[AuthProvider] Starting auth check...");
      const token = localStorage.getItem("token");
      //   console.log("[AuthProvider] Token:", token);

      if (!token) {
        //console.log("[AuthProvider] No token found, logging out...");
        setIsScreenLoaded(true);
        return;
      }

      await loginWithToken(token);
      setIsScreenLoaded(true);
      //   console.log("[AuthProvider] Screen loaded set to true");
    };

    checkAuth();
  }, []);

  if (!isScreenLoaded) {
    // console.log("[AuthProvider] Screen not loaded yet...");
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-50 z-50">
        <div className="flex flex-col items-center space-y-6">
          {/* Spinner */}
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>

          {/* Animated text */}
          <p className="text-gray-700 text-lg font-semibold animate-pulse">
            Please Wait...
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
